import Vue from 'vue';
import Component from 'vue-class-component';
import SidebarComponent from '@/components/sidebar/sidebar.component.vue';
import HeaderComponent from '@/components/header/header.component.vue';
import LoaderComponent from '@/components/loader/loader.component.vue';
import ModalPermissionsComponent from '@/components/modal-permissions/modal-permissions.component.vue';
import ModalLoginComponent from '@/components/modal-login/modal-login.component.vue';
// External components
import Datepicker from 'vuejs-datepicker';
// Services
import QuestionService from '@/core/services/question.service.ts';
import SidebarService from '@/core/services/sidebar.service.ts';

@Component({
  components: {
    SidebarComponent,
    HeaderComponent,
    LoaderComponent,
    ModalPermissionsComponent,
    ModalLoginComponent,
    Datepicker
  }
})
export default class QuestionsComponent extends Vue {

  questionService: any = new QuestionService();
  sidebarService: any = new SidebarService();
  searchFlag: any = [];
  isLoading: boolean = false;
  modal: boolean = false;
  logInModal: boolean = false;
  showModal: boolean = false;
  deleteIcon: boolean = false;
  nextPositionDisabled: boolean = false;
  previousPositionDisabled: boolean = true;
  pagination: boolean = true;
  questionToDelete: any;
  questionList: any = [];
  filterQuestionList: any = [];
  search: string = "";
  question: string = "";
  searchByDate: any = "";
  createdAt: string = "";
  filterConcatDate: string = "";
  pageOffset: number = 0;
  itemsPerPage: number = 50;
  totalPages: number;
  currentPage: number = 1;
  nextPage: number = 2;
  totalOfQuestion: number = 0;
  itemsOfFrom: number = 0;
  itemsOfTo: number = 0;

  mounted (){
    const _ = this;
    _.getAll(_.pageOffset, _.itemsPerPage);
    _.filterDate();
  }

  filterByDate(){
    const _ = this;
    _.deleteIcon = true;
    let day = _.searchByDate.getDate() < 10 ? '0' + _.searchByDate.getDate() : _.searchByDate.getDate();
    let month = _.searchByDate.getMonth() < 10 ? '0' + (_.searchByDate.getMonth() + 1) : _.searchByDate.getMonth() + 1;
    let year = _.searchByDate.getFullYear();
    _.filterConcatDate = `${year}-${month}-${day}`;
    _.filterQuestionList = _.questionList.filter((role) => {
      let parseDate: any = role.createdAt.split('T');
      parseDate = parseDate[0];
      return _.filterConcatDate == parseDate;
    })
  }

  deleteDate(){
    const _ = this;
    _.filterConcatDate = '';
    _.deleteIcon = false;
    if(_.filterConcatDate == ''){
      _.searchByDate = '';
      _.filterQuestionList = _.questionList;
      return;
    }
  }

  filterDate(date: any = ''){
    const _ = this;
    date = date.split("T");
    date = date[0];
    return date;
  }

  closeSidebar(){
    const _ = this;
    _.sidebarService.close();
  }

  openModal(id){
    const _ = this;
    _.questionToDelete = id;
    _.modal = true;
  }

  getAll(pageOffset = 0, itemsPerPage = 50){
    const _ = this;
    _.isLoading = true;
    _.questionService.getAll(pageOffset, itemsPerPage).then((data: any) => {
      _.questionList = data['data'].questions;
      _.filterQuestionList = data['data'].questions;
      console.log(data['data']);
      _.totalOfQuestion = data['data'].total;
      _.totalPages = Math.ceil(_.totalOfQuestion / itemsPerPage);
      if(_.totalPages <= 1){
        _.pagination = false;
      }
      if(pageOffset == 0){
        _.itemsOfFrom = 1;
        _.itemsOfTo = _.questionList.length;
        _.previousPositionDisabled = true;
        console.log(_.itemsOfTo, '555');
      }
      if(pageOffset != 0){
        _.previousPositionDisabled = false;
      }
      if (pageOffset == _.totalPages - 1){
        _.itemsOfTo = _.totalOfQuestion;
      }
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
    .catch((err: any) => {
      if(err.response.data.message.includes('Invalid or inexistent user')){
        localStorage.removeItem('tk_auth');
        _.logInModal = true;
      }
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
  }

  // getSurveyNameByQuestion(surveyId){
  //   const _ = this;
  //   // return 'map'
  //   _.questionService.getSurveyById(surveyId).then((data: any) => {
  //     console.log(data['data'].survey.name);
  //     return data['data'].survey.name;
  //   })
  // }

  delete_question(inactive){
    const _ = this;
    _.isLoading = true;
    _.questionService.delete_question(_.questionToDelete, inactive).then((data: any) => {
      _.get();
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
    .catch((err: any) => {
      _.isLoading = false;
    })
  }

  nextPageAction(){
    const _ = this;
    _.itemsOfTo = (_.itemsOfTo + _.questionList.length);
    console.log(_.itemsOfTo, 'incremento 1')
    _.itemsOfFrom = (_.itemsOfFrom + _.questionList.length);
    console.log(_.itemsOfFrom, 'incremento 2')

    _.pageOffset++;
    _.currentPage++;
    _.nextPage++;
    _.getAll(_.pageOffset);

    if(_.totalPages == _.currentPage){
      _.nextPositionDisabled = true;
      console.log(_.nextPositionDisabled, '98898')
      return
    }
  }

  previousPageAction(){
    const _ = this;
    if(_.currentPage == 1){
      return
    }
    _.itemsOfTo = _.itemsOfTo - _.questionList.length;
    _.itemsOfFrom = _.itemsOfFrom - _.questionList.length;
    _.pageOffset--;
    _.currentPage--;
    _.nextPage--;
    _.getAll(_.pageOffset);

    if(_.totalPages != _.currentPage){
      _.nextPositionDisabled = false;
      console.log(_.nextPositionDisabled, 'false')
      return
    }
  }
}
